import LayoutWrapper from "../components/LayoutWrapper";
import HeaderBar from "../components/HeaderBar";
import { useState, useEffect, useContext, useMemo } from "react";
import { ThemeContext } from "../context/ThemeContext";
import getCurrentSkin from "../utils/getCurrentSkin";

import axios from "axios";
import Skeleton from "react-loading-skeleton";
import { toast, ToastContainer } from "react-toastify";

const BranchItemsStockUpdate = () => {
  const { isDark, skin, setSkin } = useContext(ThemeContext);
  const currentSkin = getCurrentSkin(skin);
  const { baseColor, baseShade } = currentSkin;
  const buttonClass = `bg-${baseColor}-${baseShade}`;
  const hoverClass = `hover:bg-${baseColor}-700`;

  const finYearId = localStorage.getItem("finYearId") || "";
  const finYear = localStorage.getItem("finYear") || "";
  const branchId = localStorage.getItem("branchId") || "";
  const branch = localStorage.getItem("branchType") || "";
  const userId = localStorage.getItem("userId") || "";

  const commonHeaders = useMemo(
    () => ({
      "x-finyearid": finYearId,
      "x-finyear": finYear,
      "x-branchid": branchId,
      "x-branch": branch,
      "x-userid": userId,
    }),
    [finYearId, finYear, branchId, branch, userId]
  );

  const [limit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(1);
const [branches, setBranches] = useState([]);
  const [stores, setStores] = useState([]);
  const [categories, setCategories] = useState([]);
const [items, setItems] = useState([]);
  const [allItems, setAllItems] = useState([]);
    const [loading, setLoading] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);

  const [filters, setFilters] = useState({
    branchid: "",
    storeid: "",
    itemcategorycode: "",
    itemname: "",
    itemcode: "",
  });

  useEffect(() => {
    fetchBranches();
    fetchCategories();
  }, []);

useEffect(() => {
    if (filters.branchid) fetchStores(filters.branchid);
  }, [filters.branchid]);

  const handleBranchChange = (value) => {
    setFilters((prev) => ({
      ...prev,
      branchid: value,
      storeid: "",
    }));
  };

useEffect(() => {
    if (filters.storeid) {
      setPage(1);
    }
  }, [filters.storeid, filters.itemcategorycode, filters.itemname, filters.itemcode]);

  useEffect(() => {
    if (filters.storeid) {
      fetchItems();
    }
  }, [page]);

  useEffect(() => {
    const start = (page - 1) * limit;
    setItems(allItems.slice(start, start + limit));
  }, [allItems, page, limit]);

const fetchBranches = async () => {
    try {
      const res = await axios.get("https://nissi-india.com/api/branchItems_branches", {
        headers: commonHeaders,
      });

      console.log("Branches Response:", res.data);

      if (res.data?.branches?.length) {
        setBranches(res.data.branches);

        const defaultBranch =
          branchId || res.data.branches[0].fld_Branchid?.toString() || "";

        setFilters((prev) => ({
          ...prev,
          branchid: prev.branchid || defaultBranch,
        }));
      }
    } catch (err) {
      toast.error("Failed to load branches");
    }
  };

  const fetchStores = async (branchid) => {
    try {
      const res = await axios.get(
        `https://nissi-india.com/api/branchItemsStock_stores?branchid=${branchid}`,
        {
          headers: commonHeaders,
        }
      );

      console.log("Stores Response:", res.data);

      if (res.data?.stores?.length) {
        setStores(res.data.stores);
        setFilters((prev) => ({
          ...prev,
          storeid: res.data.stores[0].fld_storeid,
        }));
      }
    } catch (err) {
      toast.error("Failed to load stores");
    }
  };

const fetchCategories = async () => {
    try {
      const res = await axios.get("https://nissi-india.com/api/branchItems_cat", {
        headers: commonHeaders,
      });

      if (res.data?.cat?.length) {
        setCategories(res.data.cat);
        // Default stays empty → "All Categories" on first load
      }
    } catch (err) {
      toast.error("Failed to load categories");
    }
  };


  const fetchItems = async () => {
    setLoading(true);
    try {
      const res = await axios.get("https://nissi-india.com/api/branchItemStock_list", {
        headers: commonHeaders,
params: {
          storeid: filters.storeid,
          itemcategoryid: filters.itemcategorycode || "Select",
          itemname: filters.itemname,
          itemcode: filters.itemcode,
          page,
          pageSize: limit,
        },
      });

      console.log("Items Response:", res.data);

const editableItems = res.data?.items?.map((item) => ({
        ...item,
        // FIX: the SP (usp_AdminGetBranchExistsItemsList) returns the column
        // as "fld_newopeningstock" (no underscore between new/opening), not
        // "fld_new_opening_stock". The old key never existed on the response,
        // so this always silently fell back to fld_opening_stock, making the
        // saved New OB Stock value appear not to persist.
        fld_new_opening_stock: item.fld_newopeningstock ?? item.fld_opening_stock,
        fld_itemPrice: item.fld_itemPrice ?? item.fld_lastpurchaseprice ?? 0,
        fld_remarks: item.fld_remarks || "",
      })) || [];
      setAllItems(editableItems);
      const count = editableItems.length;
      setTotalCount(count);
      setTotalPages(Math.max(1, Math.ceil(count / limit)));
      setSelectedItems([]);

      console.log("Item Codes:", editableItems?.map((i) => i.fld_itemcode));
    } catch (err) {
      toast.error("Failed to fetch items");
    } finally {
      setLoading(false);
    }
  };

  const handleSelectItem = (e, itemCode) => {
    if (e.target.checked) {
      setSelectedItems((prev) => [...new Set([...prev, itemCode])]);
    } else {
      setSelectedItems((prev) => prev.filter((code) => code !== itemCode));
    }
  };

  const handleSelectAll = (e) => {
    const pageItemCodes = items.map((i) => i.fld_itemcode);
    if (e.target.checked) {
      setSelectedItems((prev) => [...new Set([...prev, ...pageItemCodes])]);
    } else {
      setSelectedItems((prev) => prev.filter((code) => !pageItemCodes.includes(code)));
    }
  };

  const handleSearch = () => {
    setPage(1);
    fetchItems();
  };

const handleSubmitStockUpdate = async () => {
    if (selectedItems.length === 0) {
      toast.warning("Please select at least one item to save.");
      return;
    }

    const selectedRows = items.filter((item) =>
      selectedItems.includes(item.fld_itemcode)
    );

const isEmpty = (v) => v === "" || v === null || v === undefined;

    // FIX: negative and missing values were lumped into one generic message
    // ("Please fill New OB Stock, Price, and OP Date") which didn't tell
    // the user which field was actually the problem. Split into distinct
    // reasons so each item's toast names the real issue.
    const missingRows = [];
    const negativeRows = [];

    selectedRows.forEach((item) => {
      const stock = item.fld_new_opening_stock;
      const price = item.fld_itemPrice;
      const opdate = item.fld_date;

      const stockMissing = isEmpty(stock) || isNaN(Number(stock));
      const priceMissing = isEmpty(price) || isNaN(Number(price));
      const dateMissing = isEmpty(opdate);

      if (stockMissing || priceMissing || dateMissing) {
        missingRows.push(item.fld_itemcode);
        return;
      }

      if (Number(stock) < 0 || Number(price) < 0) {
        negativeRows.push(item.fld_itemcode);
      }
    });

    if (missingRows.length > 0) {
      toast.error(
        `Please fill New OB Stock, Price, and OP Date for: ${missingRows.join(", ")}`
      );
      return;
    }

    if (negativeRows.length > 0) {
      toast.error(
        `New OB Stock and Price cannot be negative for: ${negativeRows.join(", ")}`
      );
      return;
    }

    const payload = {
      branchid: filters.branchid,
      storeid: filters.storeid,
      loginuserid: Number(userId || 0),
      items: selectedRows.map((item) => ({
        isChecked: true,
        itemid: item.fld_itemid,
        itemcode: item.fld_itemcode,
        hsncode: item.fld_hsncode || "",
        opstock: Number(item.fld_new_opening_stock || 0),
        oldstock: Number(item.fld_opening_stock || 0),
        minstock: item.fld_minstock || 0,
        maxstock: item.fld_maxstock || 0,
        price: Number(item.fld_itemPrice || 0),
        opdate: item.fld_date || "",
        location: item.fld_location || "",
        remarks: item.fld_remarks || "",
        serialData: [],
      })),
    };

    try {
      const res = await axios.post(
        "https://nissi-india.com/api/branchItemStock_submit",
        payload,
        {
          headers: commonHeaders,
        }
      );

      console.log("Submit Response:", res.data);

      if (res.data.success) {
        toast.success("Stock updated successfully");
        fetchItems();
      } else {
        toast.error(res.data.message || "Submit failed");
      }
    } catch {
      toast.error("Submit request failed");
    }
  };

  const handleInputChange = (code, field, value) => {
    setItems((prev) =>
      prev.map((item) =>
        item.fld_itemcode === code ? { ...item, [field]: value } : item
      )
    );
  };

  return (
    <LayoutWrapper>
      <HeaderBar title="Branch Item Stock Update" setSkin={setSkin} currentSkin={skin} />

      <div
        className={`relative overflow-hidden rounded-3xl shadow-2xl border transition-all duration-300 ${
          isDark
            ? "bg-gradient-to-br from-gray-900/95 via-gray-800/90 to-gray-900/95 backdrop-blur-xl border-gray-700/50 text-white"
            : "bg-gradient-to-br from-white via-gray-50/50 to-white backdrop-blur-sm border-gray-200/60 text-gray-900"
        }`}
      >
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div
            className={`absolute -top-40 -right-40 w-80 h-80 rounded-full opacity-10 ${
              isDark ? `bg-${baseColor}-400 animate-pulse` : `bg-${baseColor}-200 animate-pulse`
            }`}
          ></div>
          <div
            className={`absolute -bottom-40 -left-40 w-80 h-80 rounded-full opacity-10 ${
              isDark ? `bg-${baseColor}-500 animate-pulse` : `bg-${baseColor}-300 animate-pulse`
            }`}
          ></div>
          <div
            className={`absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 rounded-full opacity-5 ${
              isDark
                ? `bg-gradient-to-r from-${baseColor}-400 to-${baseColor}-600`
                : `bg-gradient-to-r from-${baseColor}-200 to-${baseColor}-400`
            }`}
          ></div>
        </div>

        <div className="relative z-10 p-8 border-b border-gray-200/20">
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
            <div>
              <h1 className="text-3xl font-bold bg-gradient-to-r from-gray-900 via-gray-700 to-gray-900 dark:from-white dark:via-gray-200 dark:to-white bg-clip-text text-transparent">
                Stock Update Management
              </h1>
              <p className={`text-sm mt-2 ${isDark ? "text-gray-400" : "text-gray-600"}`}>
                Update opening stock quantities and prices for branch items
              </p>
            </div>
            <div className="flex items-center gap-3">
              <div
                className={`px-4 py-2 rounded-full text-sm font-medium ${
                  isDark ? "bg-gray-800/60 text-gray-300" : "bg-gray-100/80 text-gray-600"
                }`}
              >
                📊 {totalCount} Items
              </div>
              {selectedItems.length > 0 && (
                <div
                  className={`px-4 py-2 rounded-full text-sm font-medium ${
                    isDark
                      ? `bg-${baseColor}-900/40 text-${baseColor}-300`
                      : `bg-${baseColor}-100 text-${baseColor}-700`
                  }`}
                >
                  ✓ {selectedItems.length} Selected
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="relative z-10 p-8">
          <div
            className={`p-6 rounded-2xl border backdrop-blur-sm ${
              isDark
                ? "bg-gray-800/50 border-gray-700/50"
                : "bg-white/80 border-gray-200/60 shadow-lg"
            }`}
          >
            <h2 className="text-xl font-semibold mb-6 flex items-center gap-2">
              <span className="text-2xl">🎯</span>
              Filter Items
            </h2>

<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-6 gap-6">
              <div className="space-y-2">
                <label className="block text-sm font-medium opacity-90">Branch</label>
                <select
                  className={`w-full border rounded-xl px-4 py-3 transition-all duration-200 focus:ring-4 focus:ring-${baseColor}-300/30 focus:border-${baseColor}-400 ${
                    isDark
                      ? "bg-gray-700/50 border-gray-600 text-white"
                      : "bg-white border-gray-300 text-gray-900"
                  }`}
                  value={filters.branchid}
                  onChange={(e) => handleBranchChange(e.target.value)}
                >
                  <option value="">Select Branch</option>
                  {branches.map((branchRow) => (
                    <option key={branchRow.fld_Branchid} value={branchRow.fld_Branchid}>
                      {branchRow.fld_BranchName}
                    </option>
                  ))}
                </select>
              </div>

              <div className="space-y-2">
                <label className="block text-sm font-medium opacity-90">Store</label>
                <select
                  className={`w-full border rounded-xl px-4 py-3 transition-all duration-200 focus:ring-4 focus:ring-${baseColor}-300/30 focus:border-${baseColor}-400 ${
                    isDark
                      ? "bg-gray-700/50 border-gray-600 text-white"
                      : "bg-white border-gray-300 text-gray-900"
                  }`}
                  value={filters.storeid}
                  onChange={(e) => setFilters({ ...filters, storeid: e.target.value })}
                >
                  <option value="">Select Store</option>
                  {stores.map((store) => (
                    <option key={store.fld_storeid} value={store.fld_storeid}>
                      {store.fld_storename}
                    </option>
                  ))}
                </select>
              </div>

              <div className="space-y-2">
                <label className="block text-sm font-medium opacity-90">Category</label>
<select
                  className={`w-full border rounded-xl px-4 py-3 transition-all duration-200 focus:ring-4 focus:ring-${baseColor}-300/30 focus:border-${baseColor}-400 ${
                    isDark
                      ? "bg-gray-700/50 border-gray-600 text-white"
                      : "bg-white border-gray-300 text-gray-900"
                  }`}
                  value={filters.itemcategorycode}
                  onChange={(e) => setFilters({ ...filters, itemcategorycode: e.target.value })}
                >
                  <option value="">All Categories</option>
                  {categories.map((cat) => (
                    <option key={cat.fld_itemcategoryid} value={cat.fld_itemcategoryid}>
                      {cat.fld_itemcategory_name || "(Unnamed Category)"}
                    </option>
                  ))}
                </select>
              </div>

              <div className="space-y-2">
                <label className="block text-sm font-medium opacity-90">Item Name</label>
                <input
                  className={`w-full border rounded-xl px-4 py-3 transition-all duration-200 focus:ring-4 focus:ring-${baseColor}-300/30 focus:border-${baseColor}-400 ${
                    isDark
                      ? "bg-gray-700/50 border-gray-600 text-white placeholder-gray-400"
                      : "bg-white border-gray-300 text-gray-900 placeholder-gray-500"
                  }`}
                  placeholder="Search by name..."
                  value={filters.itemname}
                  onChange={(e) => setFilters({ ...filters, itemname: e.target.value })}
                />
              </div>

              <div className="space-y-2">
                <label className="block text-sm font-medium opacity-90">Item Code</label>
                <input
                  className={`w-full border rounded-xl px-4 py-3 transition-all duration-200 focus:ring-4 focus:ring-${baseColor}-300/30 focus:border-${baseColor}-400 ${
                    isDark
                      ? "bg-gray-700/50 border-gray-600 text-white placeholder-gray-400"
                      : "bg-white border-gray-300 text-gray-900 placeholder-gray-500"
                  }`}
                  placeholder="Search by code..."
                  value={filters.itemcode}
                  onChange={(e) => setFilters({ ...filters, itemcode: e.target.value })}
                />
              </div>

              <div className="flex items-end">
                <button
                  onClick={handleSearch}
                  className={`w-full px-6 py-3 text-white rounded-xl font-medium transition-all duration-300 transform hover:scale-105 hover:shadow-lg ${buttonClass} ${hoverClass} focus:ring-4 focus:ring-${baseColor}-300/30`}
                >
                  🔍 Search
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="relative z-10 px-8 pb-8">
          <div
            className={`rounded-2xl border backdrop-blur-sm overflow-hidden ${
              isDark
                ? "bg-gray-800/50 border-gray-700/50"
                : "bg-white/90 border-gray-200/60 shadow-xl"
            }`}
          >
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 p-6 border-b border-gray-200/20">
              <div>
                <h3 className="text-lg font-semibold flex items-center gap-2">
                  <span className="text-xl">📋</span>
                  Stock Items
                </h3>
                <p className={`text-sm ${isDark ? "text-gray-400" : "text-gray-600"}`}>
                  Select items to update stock quantities and prices
                </p>
              </div>

              <div className="flex gap-3">
                <button
                  onClick={handleSubmitStockUpdate}
                  disabled={selectedItems.length === 0}
                  className={`flex items-center gap-2 px-6 py-3 rounded-xl font-medium transition-all duration-300 transform hover:scale-105 text-white focus:ring-4 focus:ring-green-300/30 ${
                    selectedItems.length === 0
                      ? "bg-gray-400 cursor-not-allowed hover:scale-100"
                      : "bg-green-600 hover:bg-green-700 hover:shadow-lg"
                  }`}
                >
                  <span className="text-lg">✅</span>
                  Save Changes ({selectedItems.length})
                </button>
              </div>
            </div>

            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead className={`${isDark ? `bg-${baseColor}-900/50` : `bg-${baseColor}-${baseShade}`} text-white`}>
                  <tr>
                    <th className="px-4 py-4 text-center font-semibold border-r border-white/10">
                      <input
                        type="checkbox"
                        className={`w-5 h-5 rounded border-2 transition-all duration-200 focus:ring-2 focus:ring-white/30 ${
                          items.length > 0 && items.every((item) => selectedItems.includes(item.fld_itemcode))
                            ? `bg-white border-white`
                            : `border-white/50 bg-transparent`
                        }`}
                        checked={
                          items.length > 0 &&
                          items.every((item) => selectedItems.includes(item.fld_itemcode))
                        }
                        onChange={handleSelectAll}
                      />
                    </th>
                    {[
                      "S.No",
                      "Code",
                      "Item Name",
                      "Part NO",
                      "UOM",
                      "OB Stock",
                      "New OB Stock",
                      "Price",
                      "Total Value",
                      "Remarks",
                      "OP Date",
                    ].map((header, index) => (
                      <th
                        key={index}
                        className="px-4 py-4 text-left font-semibold border-r border-white/10 last:border-r-0"
                      >
                        {header}
                      </th>
                    ))}
                  </tr>
                </thead>

                <tbody className={isDark ? "text-gray-200" : "text-gray-700"}>
                  {loading ? (
                    <tr>
                      <td colSpan="12" className="p-6">
                        <div className="space-y-3">
                          {[...Array(5)].map((_, i) => (
                            <Skeleton key={i} height={50} className="rounded-lg" />
                          ))}
                        </div>
                      </td>
                    </tr>
                  ) : items.length === 0 ? (
                    <tr>
                      <td colSpan="12" className="text-center py-12">
                        <div className="flex flex-col items-center gap-4">
                          <span className="text-6xl opacity-30">📦</span>
                          <p className="text-lg font-medium opacity-70">No items found</p>
                          <p className={`text-sm ${isDark ? "text-gray-400" : "text-gray-500"}`}>
                            Try adjusting your search filters
                          </p>
                        </div>
                      </td>
                    </tr>
                  ) : (
                    items.map((item, i) => (
                      <tr
                        key={item.fld_itemcode}
                        className={`border-b transition-colors duration-200 ${
                          isDark
                            ? "border-gray-700/50 hover:bg-gray-700/30"
                            : "border-gray-200/50 hover:bg-gray-50/80"
                        }`}
                      >
                        <td className="px-4 py-4 text-center">
                          <input
                            type="checkbox"
                            className={`w-5 h-5 rounded border-2 transition-all duration-200 focus:ring-2 focus:ring-${baseColor}-300/50 ${
                              selectedItems.includes(item.fld_itemcode)
                                ? `bg-${baseColor}-${baseShade} border-${baseColor}-${baseShade}`
                                : `border-gray-300 ${isDark ? "bg-gray-700" : "bg-white"}`
                            }`}
                            checked={selectedItems.includes(item.fld_itemcode)}
                            onChange={(e) => handleSelectItem(e, item.fld_itemcode)}
                          />
                        </td>
                        <td className="px-4 py-4 font-medium">{(page - 1) * limit + i + 1}</td>
                        <td className="px-4 py-4 font-mono text-xs">{item.fld_itemcode}</td>
                        <td className="px-4 py-4 font-medium max-w-[200px] truncate" title={item.fld_itemname}>
                          {item.fld_itemname}
                        </td>
                        <td className="px-4 py-4">{item.fld_itemPartNo || "-"}</td>
                        <td className="px-4 py-4">{item.fld_uomname}</td>
                        <td className="px-4 py-4">
                          <div
                            className={`px-3 py-2 rounded-lg text-center font-medium ${
                              isDark ? "bg-gray-700/50 text-gray-200" : "bg-gray-100 text-gray-700"
                            }`}
                          >
                            {item.fld_opening_stock}
                          </div>
                        </td>

                                               <td className="px-4 py-4">
                          <input
                            type="number"
                            min="0"
                            value={item.fld_new_opening_stock || ""}
                            onChange={(e) =>
                              handleInputChange(item.fld_itemcode, "fld_new_opening_stock", e.target.value)
                            }
                            className={`w-24 border rounded-lg px-3 py-2 text-sm transition-all duration-200 focus:ring-2 focus:ring-${baseColor}-300/50 ${
                              isDark
                                ? "bg-gray-700/50 border-gray-600 text-white"
                                : "bg-white border-gray-300 text-gray-900"
                            }`}
                          />
                        </td>

                        <td className="px-4 py-4">
                          <input
                            type="number"
                            step="0.01"
                            min="0"
                            value={item.fld_itemPrice || ""}
                            onChange={(e) =>
                              handleInputChange(item.fld_itemcode, "fld_itemPrice", e.target.value)
                            }
                            className={`w-24 border rounded-lg px-3 py-2 text-sm transition-all duration-200 focus:ring-2 focus:ring-${baseColor}-300/50 ${
                              isDark
                                ? "bg-gray-700/50 border-gray-600 text-white"
                                : "bg-white border-gray-300 text-gray-900"
                            }`}
                          />
                        </td>

                        <td className="px-4 py-4">
                          <div
                            className={`px-3 py-2 rounded-lg text-center font-medium ${
                              isDark ? "bg-blue-900/30 text-blue-300" : "bg-blue-100 text-blue-700"
                            }`}
                          >
                            ₹{(Number(item.fld_new_opening_stock || 0) * Number(item.fld_itemPrice || 0)).toFixed(2)}
                          </div>
                        </td>

                        <td className="px-4 py-4">
                          <input
                            type="text"
                            value={item.fld_remarks || ""}
                            onChange={(e) =>
                              handleInputChange(item.fld_itemcode, "fld_remarks", e.target.value)
                            }
                            className={`w-32 border rounded-lg px-3 py-2 text-sm transition-all duration-200 focus:ring-2 focus:ring-${baseColor}-300/50 ${
                              isDark
                                ? "bg-gray-700/50 border-gray-600 text-white"
                                : "bg-white border-gray-300 text-gray-900"
                            }`}
                            placeholder="Add remarks..."
                          />
                        </td>

                        <td className="px-4 py-4">{item.fld_date}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-between p-6 border-t border-gray-200/20 gap-4">
              <div className={`text-sm ${isDark ? "text-gray-300" : "text-gray-600"}`}>
                Showing{" "}
                <span className={`font-semibold text-${baseColor}-600`}>
                  {(page - 1) * limit + 1}
                </span>{" "}
                to{" "}
                <span className={`font-semibold text-${baseColor}-600`}>
                  {Math.min(page * limit, (page - 1) * limit + items.length)}
                </span>{" "}
                of <span className={`font-semibold text-${baseColor}-600`}>{totalCount}</span> results
              </div>

              <div
                className={`inline-flex rounded-2xl shadow-lg overflow-hidden border ${
                  isDark ? "border-gray-700 bg-gray-800" : "border-gray-300 bg-white"
                }`}
              >
                <button
                  onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
                  disabled={page === 1}
                  className={`px-6 py-3 text-sm font-medium transition-all duration-200 ${
                    page === 1
                      ? "text-gray-400 cursor-not-allowed"
                      : `hover:bg-${baseColor}-50 text-gray-700 dark:hover:bg-${baseColor}-800/30 dark:text-gray-200`
                  }`}
                >
                  ← Prev
                </button>

                {[...Array(Math.min(totalPages, 5))].map((_, idx) => {
                  let pageNum;
                  if (totalPages <= 5) {
                    pageNum = idx + 1;
                  } else if (page <= 3) {
                    pageNum = idx + 1;
                  } else if (page >= totalPages - 2) {
                    pageNum = totalPages - 4 + idx;
                  } else {
                    pageNum = page - 2 + idx;
                  }

                  return (
                    <button
                      key={pageNum}
                      onClick={() => setPage(pageNum)}
                      className={`px-4 py-3 text-sm font-medium transition-all duration-200 ${
                        page === pageNum
                          ? `bg-${baseColor}-${baseShade} text-white shadow-lg`
                          : `hover:bg-${baseColor}-50 text-gray-700 dark:hover:bg-${baseColor}-800/30 dark:text-gray-200`
                      }`}
                    >
                      {pageNum}
                    </button>
                  );
                })}

                <button
                  onClick={() => setPage((prev) => Math.min(prev + 1, totalPages))}
                  disabled={page === totalPages}
                  className={`px-6 py-3 text-sm font-medium transition-all duration-200 ${
                    page === totalPages
                      ? "text-gray-400 cursor-not-allowed"
                      : `hover:bg-${baseColor}-50 text-gray-700 dark:hover:bg-${baseColor}-800/30 dark:text-gray-200`
                  }`}
                >
                  Next →
                </button>
              </div>
            </div>
          </div>
        </div>

        {selectedItems.length > 0 && (
          <div className="fixed bottom-6 right-6 z-50">
            <div
              className={`p-4 rounded-2xl shadow-2xl border backdrop-blur-md ${
                isDark
                  ? "bg-gray-900/90 border-gray-700/50 text-white"
                  : "bg-white/90 border-gray-200/60 text-gray-900"
              }`}
            >
              <div className="flex items-center gap-4">
                <div className="text-sm">
                  <span className="font-medium">{selectedItems.length}</span> items selected
                </div>
                <button
                  onClick={handleSubmitStockUpdate}
                  className="flex items-center gap-2 px-4 py-2 rounded-xl font-medium transition-all duration-300 transform hover:scale-105 bg-green-600 hover:bg-green-700 text-white shadow-lg"
                >
                  <span>✅</span>
                  Update Stock
                </button>
              </div>
            </div>
          </div>
        )}
      </div>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme={isDark ? "dark" : "light"}
        className="mt-16"
      />
    </LayoutWrapper>
  );
};

export default BranchItemsStockUpdate;